import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
//Quinlan
import BaseMixer from "@/router/views/BaseMixer";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Loader from "@/components/widgets/loader.vue";
import USMap from "./USMap.vue";
import { DashboardModule } from "@/store/modules/dashboard.module";
let DashBoard = /** @class */ (() => {
    let DashBoard = class DashBoard extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.stateSelected = "States";
            this.selectedMapStates = [];
            this.selectedAnalystId = "";
            this.isAnalystMapStatesLoaded = false;
            this.isLoading = false;
        }
        allStatesChangeHandler() {
            this.selectedMapStates = this.adminDetail.mapStates;
        }
        byAnalystChangeHandler() {
            if (!this.isAnalystMapStatesLoaded) {
                this.isLoading = true;
                DashboardModule.GetMapAnalystDetails().then((response) => {
                    this.isLoading = false;
                    this.isAnalystMapStatesLoaded = true;
                    this.chooseAnalystMapStates(this.adminDetail.mapAnalystDetails[0].userId);
                });
            }
            else {
                this.chooseAnalystMapStates(this.adminDetail.mapAnalystDetails[0].userId);
            }
        }
        chooseAnalystMapStates(userId) {
            this.selectedAnalystId = userId;
            this.selectedMapStates = this.adminDetail.mapAnalystDetails.find((x) => x.userId == userId).states;
        }
        get adminDetail() {
            return DashboardModule.adminDetail;
        }
        created() {
            this.selectedMapStates = this.adminDetail.mapStates;
        }
    };
    DashBoard = __decorate([
        Component({
            name: "AdminStatisticsComponent",
            components: {
                SectionLoader,
                Loader,
                USMap,
            },
        })
    ], DashBoard);
    return DashBoard;
})();
export default DashBoard;
